import React, {KeyboardEventHandler} from 'react';
import {createTheme, TextField, ThemeProvider} from '@mui/material';
import {FmComponent} from '../types/types';
import './style.scss';
import {color} from '../styles/variables';
import {isPRD} from '../../../utlis/vars';

interface iInput extends FmComponent {
  type?: React.HTMLInputTypeAttribute;
  value: unknown;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  label: string;
  readOnly?: boolean,
  style?: React.CSSProperties;
  required?: boolean;
}

const theme = createTheme({
  palette: {
    primary: {
      main: color.blue
    }
  }
});

const Input = ({
                 id,
                 className,
                 'data-testid': dataTestId,
                 type = 'text',
                 value,
                 onChange,
                 onKeyUp,
                 label,
                 style,
                 readOnly,
                 required = false
               }: iInput): React.ReactElement => {
  return (
    <ThemeProvider theme={theme}>
      <TextField
        variant="standard"
        label={label}
        id={id}
        className={`fm-input${className ? ` ${className}` : ''}`}
        data-testid={isPRD ? undefined : dataTestId}
        type={type}
        value={value}
        onChange={onChange}
        onKeyUp={onKeyUp}
        style={{...style, margin: '10px 0'}}
        required={required}
        color="primary"
        InputLabelProps={{required: false}}
        InputProps={{readOnly: readOnly ?? false}}
      />
    </ThemeProvider>
  );
};

export default Input;
